module.exports = __webpack_public_path__ + "static/media/JO.cc1230d0.svg";